import loginSlice from './loginSlice';
import contentSlice from './contentSlice';
// import openApiActions from './openApiActions';
import messageReducer from './messageSlice';
import tutorialSlice from './tutorialSlice';
import simpleViewSlice from './simpleViewSlice';
import newsSlice from './newsSlice';
import { combineReducers } from '@reduxjs/toolkit';

const rootReducer = combineReducers({
    message: messageReducer,
    login: loginSlice,
    content: contentSlice,
    // openApi: openApiActions,
    tutorial: tutorialSlice,
    simpleView: simpleViewSlice,
    news: newsSlice,
});

export default rootReducer;
